import AttachFileIcon from '@mui/icons-material/AttachFile';
import LanguageIcon from '@mui/icons-material/Language';
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import "../CSS/Layout.css";
import "../CSS/Resources.css";
import { ResourceType, machineShop, readingMaterial, safetyTraining, softwares, uhvTechniques } from "../Configurations/ResourcesList";
import { redirect } from '../utils/tools';

export default function ResourcesPage() {
  const [tabId, setTabId] = useState(0);

  function getLinkSection(linkList) {
    const links = [];
    const youtubeList = [];
    for (var i = 0; i < linkList.length; i++) {
      let detail = linkList[i];
      switch (detail.type) {
        case ResourceType.YOUTUBE:
          youtubeList.push(<Card className="youtube-card" key={i}>
            <iframe
              src={detail.link}
              className='iframe-style'
              title="YouTube video player"
              loading='lazy'
              // frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
            />
            <CardContent>
              <Typography color="secondary" mt="10px">{detail.title}</Typography>
            </CardContent>
          </Card>
          );
          break;
        case ResourceType.WEBSITE:
          links.push(<Button key={i} variant="contained" color='primary' className='resource-other-links'
            onClick={() => redirect(detail.link)} >
            <Box className='other-card'>
              <LanguageIcon />
              <Box ml="10px">
                <Typography>{detail.title}</Typography>
              </Box>
            </Box>
          </Button>);
          break;
        case ResourceType.FILE:
          links.push(
            <Button key={i} variant="contained" color='secondary' className='resource-other-links'
              onClick={() => redirect(detail.link)} >
              <Box className='other-card'>
                <AttachFileIcon />
                <Box>
                  <Typography>{detail.title}</Typography>
                </Box>
              </Box>

            </Button>
          );
          break;
        default: break;
      }
    }
    return <Box display="flex" flexDirection="column" gap="2rem">
      <Box display="flex" gap="2rem" flexWrap="wrap">
        {links}
      </Box>
      <Box display="flex" gap="2rem" flexWrap="wrap">
        {youtubeList}
      </Box>
    </Box>
  }

  const tabs = useMemo(() => {
    const names = [
      "Safety Training",
      "UHV Techniques",
      "Reading Materials",
      "Machine Shop & Maintenance",
      "Software Documents"
    ]

    const buttons = [];
    for (var i = 0; i < names.length; i++) {
      if (tabId === i) {
        buttons.push(
          <Button value={i} key={i} className='selected-tab'
            variant='text' color='primary'
            sx={{ fontSize: "1.5rem", fontWeight: 400 }}
            onClick={(event) => { setTabId(parseInt(event.target.value)); }}
          >
            {names[i]}
          </Button>
        );
      } else {
        buttons.push(
          <Button value={i} key={i} className='unselect-tab'
            variant='text' color='third'
            sx={{ fontSize: "1.5rem", fontWeight: 400 }}
            onClick={(event) => { setTabId(parseInt(event.target.value)); }}
          >
            {names[i]}
          </Button>)
      }
    }
    return <Box className="tab-list">
      {buttons}
    </Box>;
  }, [tabId]);

  const tabContent = useMemo(() => {
    if (tabId === 0) {
      return <Box className="tab-content"> {getLinkSection(safetyTraining)}</Box>;
    }
    if (tabId === 1) {
      return <Box className="tab-content"> {getLinkSection(uhvTechniques)}</Box>;
    }
    if (tabId === 2) {
      return <Box className="tab-content"> {getLinkSection(readingMaterial)}</Box>;
    }
    if (tabId === 3) {
      return <Box className="tab-content"> {getLinkSection(machineShop)}</Box>;
    }
    if (tabId === 4) {
      return <Box className="tab-content"> {getLinkSection(softwares)}</Box>;
    }
  }, [tabId]);

  return (<Box className="resource-tab-layout">
    {tabs}
    {tabContent}
  </Box>);
}